import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import about from '@/views/about'
import environment from '@/views/environment'
import department from '@/views/department'
import honour from '@/views/honour'
import news from '@/views/news/news'
import contact from '@/views/contact'
import characteristic from '@/views/characteristic/index'
import medicalRecord from '@/views/medicalRecord/index'
import medicalRecordDetail from '@/views/medicalRecord/detail'
import newsDetail from '@/views/news/detail'
import videoList from '@/views/news/videoList'
import videoDetail from '@/views/news/videoDetail'
import yuyue from '@/views/news/yuyue'
import guide from '@/views/news/guideDetail'
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(Router)
Vue.use(Vant);

export default new Router({
  mode:'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [ 
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/environment',
      name: 'environment',
      component: environment
    },
    {
      path: '/department',
      name: 'department',
      component: department
    },
    {
      path: '/characteristic',
      name: 'characteristic',
      component: characteristic
    },
    {
      path: '/medicalRecord',
      name: 'medicalRecord',
      component: medicalRecord
    },
    {
      path: '/honour',
      name: 'honour',
      component: honour
    },
    {
      path: '/medicalRecordDetail',
      name: 'medicalRecordDetail',
      component: medicalRecordDetail
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    },
    {
      path: '/videoList',
      name: 'videoList',
      component: videoList
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: videoDetail
    },
    {
      path: '/guide',
      name: 'guide',
      component: guide
    },
    {
      path: '/yuyue',
      name: 'yuyue',
      component: yuyue
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js